import { render, staticRenderFns } from "./DebtTable.vue?vue&type=template&id=11877742&scoped=true&"
import script from "./DebtTable.vue?vue&type=script&lang=js&"
export * from "./DebtTable.vue?vue&type=script&lang=js&"
import style0 from "./DebtTable.vue?vue&type=style&index=0&id=11877742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11877742",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
